import { Address4, Address6 } from 'ip-address';

import InputTextFieldChips from 'shared/components/Input/InputTextFieldChips';

export interface MulticastInfoT {
  ip: string;
  port: string;
}

interface IPNetworksItemFormMulticastInfosProps {
  addressType: string;
  defaultValues: MulticastInfoT[];
  // eslint-disable-next-line no-unused-vars
  onChange: (newdata: MulticastInfoT[]) => void;
}
function IPNetworksItemFormMulticastInfos({
  addressType,
  defaultValues,
  onChange,
}: IPNetworksItemFormMulticastInfosProps) {
  const formatMulticastInfo = (input: string, setError: any): MulticastInfoT | null => {
    const [ip, port] = input.split('/');
    if (port === undefined) {
      setError('Must follow the pattern IP/Port');
      return null;
    }
    if (port === '' || Number.isNaN(+port) || +port < 0 || +port > 65535) {
      setError('UDP port value must a number include between 0 and 65535');
      return null;
    }
    let parsedIPAddress;
    try {
      if (addressType === 'V4') {
        parsedIPAddress = new Address4(ip);
      } else {
        parsedIPAddress = new Address6(ip);
      }
    } catch (error) {
      setError(`IP${addressType} Address is not valid`);
      return null;
    }
    if (!parsedIPAddress.isMulticast()) {
      setError(`Invalid IP${addressType} multicast address - ${addressType === 'V4' ? 'Must range from 224.0.0.0 to 239.255.255.255' : 'First octet must be FF (FF00::/8)'}`);
      return null;
    }
    return { ip: parsedIPAddress.address, port };
  };

  const formatMulticastInfoLabel = (item: MulticastInfoT) => (
    `IP: ${item.ip} · Port: ${item.port}`
  );

  return (
    <InputTextFieldChips
      fullWidth
      sx={{ m: 1 }}
      name="Multicast Information"
      formatItem={formatMulticastInfo}
      formatLabel={formatMulticastInfoLabel}
      onChange={onChange}
      defaultValues={defaultValues}
      defaultHelperText="Press enter to add value - IP/Port"
    />
  );
}

export default IPNetworksItemFormMulticastInfos;
